import Tendency from './Tendency';

export default Tendency;
